<template>

    <div class="brt-map-container" ref="brt-map-container">

        <!--智石地图容器-->
        <BrtmapModule></BrtmapModule>

        <div class="brt-map-moudles" v-if="$BRT.ready">

            <!--顶部相关操作系列模块集合-->
            <TopGather></TopGather>

            <!--左侧相关操作系列模块集合-->
            <LeftGather></LeftGather>

            <!--右侧相关操作系列模块集合-->
            <RightGather></RightGather>

            <!--底部操作系列模块集合-->
            <BottomGather></BottomGather>

            <!--引入子集路由-->
            <!--<router-view></router-view>-->
            <PoiInfoDetail v-if="$mapStep.type == 'poiDetail'"></PoiInfoDetail>

            <!--功能栏目-->
            <GuideDrawer v-model="guideDrawerVisible" @on-close="onGuideDrawerClose"></GuideDrawer>

            <!--历史足迹/收藏夹-->
            <Footprint v-model="footPrintVisible" :index="tabIndex" @on-close="onFootPrintClose"></Footprint>

            <!--寻车弹框-->
            <div :class="$BRT.$findCar.timer ? 'fixed_Car_module show':'fixed_Car_module'">

                <div class="wrap-box">
                    <img src="../../../public/images/car_icon.png">
                    <span>或点此"寻车"进入</span>

                    <div class="content-box">
                        <p>需车牌一键寻车吗?</p>
                        <p>正在查看停车场地图</p>
                    </div>

                    <div class="btn-box">
                        <div class="box">
                            <a class="btn" @click="$BRT.$findCar.timer=''">不需要 ({{$BRT.$findCar.timer}})</a>
                        </div>
                        <div class="box">
                            <a class="btn" @click="gofindCar" bg="fff">立即寻车</a>
                        </div>
                    </div>
                </div>

            </div>

            <!--用户须知-->
            <div class="brt-bluetoothAndGPS-dailog" v-if="bluetoothAndGPS" @click="bluetoothAndGPS=false">

                <div class="dailog-wrap" @click.stop="">

                    <div class="h-box">开启GPS和蓝牙</div>

                    <div class="c-box"><img src="@/assets/bluetoothAndGPS.jpg" alt=""></div>

                    <div class="btn-box" @click.stop="bluetoothAndGPS=false"><a>知道了</a></div>

                </div>

            </div>


            <!--全景720实现-->
            <div class="photo-sphere-viewer-fixed" v-show="photosphereVisble">
                <div class="photosphere" id="photosphere" ref="photosphere">
                    <div class="iconfont icon-close-01" @click.stop="viewerClose"></div>
                </div>

                <div class="iconfont icon-yanjizhushou-shangchuan_tuoluoyi" @click="GyroscopePlugin"></div>
            </div>

        </div>

    </div>

</template>

<script>

    // 引入各板块模块集合
    import BrtmapModule from './modules/brtmap/Brtmap.vue'
    import TopGather from './modules/topGather/TopGather.vue'
    import LeftGather from './modules/leftGather/LeftGather.vue'
    import RightGather from './modules/rightGather/RightGather.vue'
    import BottomGather from './modules/bottomGather/BottomGather.vue'
    import PoiInfoDetail from './modules/routes/poiDetailGather/PoiDetailGather.vue'

    import { Footprint } from '@/modules/footprint'
    import { GuideDrawer } from '@/modules/guideDrawer'

    import "three"

    import {Viewer} from 'photo-sphere-viewer'

    import GyroscopePlugin from "photo-sphere-viewer/dist/plugins/gyroscope"
    import MarkersPlugin from "photo-sphere-viewer/dist/plugins/markers"

    import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
    import "photo-sphere-viewer/dist/plugins/markers.css"

    let visibleTime = '',
        photoViewer = '',
        photoViewerLS= [{
            "id": 1,
            "floor": 1,
            "name": "南广场（南入口前）",
            "lnglat": {
                "lng": 113.77538772524973,
                "lat": 22.691305544566642
            },
            imgUrl:require("./../../assets/vr01.jpg")
        }, {
            "id": 2,
            "floor": 2,
            "name": "南入口坐电梯至2楼",
            "lnglat": {
                "lng": 113.7752973382773,
                "lat": 22.692024834407988
            },
            imgUrl:require("./../../assets/vr02.jpg")
        }, {
            "id": 3,
            "floor": 1,
            "name": "南登前面的广场",
            "lnglat": {
                "lng": 113.77650600919767,
                "lat": 22.69686712137848
            },
            imgUrl:require("./../../assets/vr03.jpg")
        }, {
            "id": 4,
            "floor": 1,
            "name": "南登录大厅1楼",
            "lnglat": {
                "lng": 113.7752984695645,
                "lat": 22.69673088793253
            },
            imgUrl:require("./../../assets/vr04.jpg")
        }, {
            "id": 5,
            "floor": 1,
            "name": "北登录大厅1楼",
            "lnglat": {
                "lng": 113.77444146297357,
                "lat": 22.70301253274445
            },
            imgUrl:require("./../../assets/vr05.jpg")
        }, {
            "id": 6,
            "floor": 1,
            "name": "北登录大厅前面广场",
            "lnglat": {
                "lng": 113.7755577100547,
                "lat": 22.70315102762143
            },
            imgUrl:require("./../../assets/vr06.jpg")
        }];

    export default {
        name: "Map",

        data(){
            return {
                footPrintVisible: false,
                tabIndex: 1,  // 1：先显示收藏夹   2：先显示足迹
                guideDrawerVisible: false,
                bluetoothAndGPS:false,

                sureGoToOutMapDaliog:false,
                appVisible:false,

                photosphereVisble:false
            }
        },

        created(){
            this.bus.$off('MapFloorListen');
            this.bus.$on('MapFloorListen',res=>{
                this.floorID(res)
            });

            this.bus.$off('Map.photosphere');

            this.bus.$on('Map.photosphere',param=>{

                if(param === 1){

                    //插标
                    let cf = $VAR.map.currentMapInfo.floorNumber;

                    photoViewerLS.map(item=>{
                        if(item.maker){item.maker.empty()}

                        if(item.floor == cf){
                            item.maker = new brtmap.Symbol.DivMarker({
                                content:`<div class="wrap"><img src="${require('./../../assets/mvr.png')}"></div>`,
                                className:'point-marker svr',
                            }).addTo($VAR.map).setLnglat(item.lnglat);

                            item.maker.on('click',()=>{
                                event.stopPropagation();
                                this.viewerOpen(item);
                            })
                        }
                    })

                }
            })
        },

        methods: {

            viewerClose(){
                this.photosphereVisble = false;
            },
            GyroscopePlugin(){
                if(!photoViewer.plugins.gyroscope){
                    this.$message.info('设备不支持陀螺仪');
                    return;
                }

                photoViewer.plugins.gyroscope.toggle();
            },
            viewerOpen(item){

                this.photosphereVisble = true;

                if(!photoViewer){
                    this.$nextTick(()=>{

                        photoViewer = new Viewer({
                            container:this.$refs['photosphere'],
                            panorama:item.imgUrl,

                            plugins:[
                                GyroscopePlugin,
                                [MarkersPlugin,{
                                    markers:[
                                        // {
                                        //     // circle marker
                                        //     id: 'circle',
                                        //     circle: 20,
                                        //     x: 0,
                                        //     y: 0,
                                        //     tooltip: 'A circle marker'
                                        // },
                                        // {
                                        //     // circle marker
                                        //     id: 'circle01',
                                        //     circle: 20,
                                        //     longitude: 0,
                                        //     latitude: 0,
                                        //     anchor: 'center',
                                        //     tooltip: 'A circle marker'
                                        // },
                                        {
                                            id:"LABEL_01",
                                            className:"pv_marker no-pointer LABEL_01",
                                            latitude: -1.5389495225600918,
                                            longitude: 5.374872349722118,
                                            image: require('@/assets/markerLabel01.png'),
                                            width: 200,
                                            height: 200,
                                            scale:[1,4],
                                            anchor: 'center'
                                        }
                                    ]
                                }]
                            ],

                            navbar:false,
                            autorotateSpeed:"1.5rpm",
                            autorotateDelay:1000,
                        });

                        const gyroscopePlugin = photoViewer.getPlugin(GyroscopePlugin);
                        const markersPlugin =photoViewer.getPlugin(MarkersPlugin);

                        console.log('gyroscopePlugin',gyroscopePlugin);
                        console.log('markersPlugin',markersPlugin);

                        photoViewer.on('click',(e,data)=>{
                            console.log('data',data);
                            // markersPlugin.updateMarker({
                            //     id:"LABEL_01",
                            //     latitude: data.latitude,
                            //     longitude: data.longitude,
                            // })

                        })

                    })
                }
                else{
                    //直接切换全景图
                    photoViewer.setPanorama(item.imgUrl);
                    photoViewer.startAutorotate();
                }

            },

            onFootPrintClose () {
                console.log('footprint close');

                this.$BRT.$options.Footprint = false;
            },

            onGuideDrawerClose () {
                console.log('guide drawer close');

                this.$BRT.$options.GuideDrawer = false;

            },

            gofindCar(){
                this.$router.replace(`/findCar`);
            },

            //寻车弹窗
            showCarFixed(){

                //stopcar floorType
                let $carOpen = this.$mapStore.plugInfo.plugInfo.plugInSettings.queryCarServiceOpen == 1?true:false,
                    $carFloor = JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.map).floorType.stopcar || [],
                    $carStorageCount = this.$mapStore.plugInfo.buildingId + '_carCount',
                    customTipCount = window.localStorage.getItem($carStorageCount), //本地缓存
                    customPageCount = window.sessionStorage.getItem($carStorageCount),//页面缓存
                    isCarPark = false;

                if($VAR.map && $VAR.map.currentMapInfo){
                    isCarPark =  $carFloor.some((item)=>{return item == $VAR.map.currentMapInfo.floorID});
                }


                    // console.log('$carFloor',$carFloor,'customTipCount',customTipCount,'customPageCount',customPageCount,'isCarPark',isCarPark);

                    //关闭弹出框 防止定位再次干扰
                    if(!isCarPark){
                        this.$BRT.$findCar.timer = '';
                        return false;
                    }

                    if(!this.$mapStep.type && $carOpen && customTipCount < 3 && !customPageCount && !this.$BRT.$findCar.timer && !this.$BRT.$urlParam.share.status){   //分享点位不出现

                        if(isCarPark){

                            this.$BRT.$findCar.timer = 6;

                            let carT = setInterval(()=>{

                                if( !this.$BRT.$findCar.timer || this.$BRT.$findCar.timer <=0){
                                    clearInterval(carT);
                                    this.$BRT.$findCar.timer = '';
                                    return;
                                }

                                this.$BRT.$findCar.timer --;
                            },1000)

                            window.localStorage.setItem($carStorageCount,++customTipCount)
                            window.sessionStorage.setItem($carStorageCount,true);

                        }

                    }

            },

            floorID(v1,v2){
                v1 ? this.showCarFixed():''
            }

        },

        components: {
            BrtmapModule,
            TopGather,
            LeftGather,
            RightGather,
            BottomGather,
            PoiInfoDetail,
            Footprint,
            GuideDrawer
        },

        watch:{

            $mapStepType(v1,v2){

                window.sessionStorage.setItem('lastStep',v2);

                if(v2 != '' && v1==''){     //其他返回主页面数据清理
                    this.$mapStep.poiID = '';
                    this.bus.$emit('selectedPoint','');
                    this.$BRT.$selecte.point='';
                    this.$BRT.$marker.selected.empty();


                    this.$BRT.$selecte.startPoint = '';
                    this.$BRT.$selecte.endPoint='';
                    this.bus.$emit('startAndEnd',{type:0})

                    // $VAR.map.resetRoute();
                    // this.$BRT.$marker.start.empty();
                    // this.$BRT.$marker.end.empty();

                    //清除筛选插标
                    // if($VAR.PoiListMaker.length){
                    //     for(let i=0;i<$VAR.PoiListMaker.length;i++){
                    //         $AVR.PoiListMaker[i].maker.empty();
                    //     }
                    // }
                }

             },

            $Footprint(v1,v2){
                this.footPrintVisible = v1;
            },

            $TabIndex(v1,v2){
                this.tabIndex =v1;
            },

            $GuideDrawer(v1,v2){
                this.guideDrawerVisible = v1;
            },

            // $PoiListDrawer(v1,v2){
            //     this.poiListDrawerVisible = v1;
            // },

        },

        computed:{
            $mapStepType(){
                return this.$mapStep.type;
            },

            $Footprint(){
                return this.$BRT.$options.Footprint
            },

            $TabIndex(){
                return this.$BRT.$options.FootprintTabIndex;
            },

            $GuideDrawer(){
                return this.$BRT.$options.GuideDrawer
            }


        },

        mounted(){

            let that = this;

            setTimeout(()=>{    //防止楼层筛选出错
                if(!sessionStorage.getItem('bluetoothAndGPS_huizhang')){

                    this.bluetoothAndGPS = true;
                    sessionStorage.setItem('bluetoothAndGPS_huizhang',true);

                }else{

                    if(!this.$BRT.$urlParam.share.status){this.showCarFixed()}

                }

            },1000);
        }
    }



</script>

<style lang="less">

    @import "../../styles/cssBlock.less";

    .pv_marker{
        background-size: 100% 100%;

        &.LABEL_01{
            transform-origin: -15% -10% !important;
        }

        &.no-pointer{
            pointer-events: none;
        }
    }

    .brt-map-container{
        .absoluteByCover;

        >.brt-map-moudles{
            .absoluteByCover;
            z-index: 10;
            pointer-events: none;

            >.fixed_Car_module{
                .fixedByCover;
                z-index: 1000;
                display: none;

                &.show{
                    .flexCenter;
                }

                pointer-events: auto;

                >.wrap-box{
                    width: 85%;
                    position: relative;
                    background-color: var(--themColor);
                    border-radius: @radiusNumber * 2;
                    box-shadow: @shadowbox;

                    color: @themeReverseColor;

                    >img{
                        height: @standartHeightA8;
                        position: absolute;
                        top: -@standartHeightA8 /2;
                        left: @standartSpaceA4;
                    }
                    >span{
                        position: absolute;
                        top: @standartSpaceA4;
                        right: @standartSpaceA4;

                        font-size: @fontSizeA6;
                        color: @fontColorA4;
                    }

                    >.content-box{
                        padding-top: @standartHeightA8;
                        >p{
                            margin-bottom: @standartSpaceA1;
                            text-align: center;
                            font-size: @fontSizeA5;
                            &:first-child{
                                color:#E7D781;
                                font-size: @fontSizeA3;

                            }
                        }
                    }

                    >.btn-box{

                        .flexCenter;
                        padding: @standartSpaceA7 0px @standartSpaceA5 0px;

                        >.box{
                            flex: 1;
                            text-align: center;

                            >.btn{

                                width: 80%;
                                height: @standartHeightA2;
                                line-height: @standartHeightA2;
                                border-radius: @standartHeightA2/2;
                                display: inline-block;
                                text-align: center;
                                border:1px solid @themeReverseColor;

                                &[bg='fff']{
                                    color: var(--themColor);
                                    background-color: @themeReverseColor;

                                }

                                &:active{opacity: .8}
                            }
                        }

                    }
                }
            }

            >.brt-bluetoothAndGPS-dailog{
                pointer-events: auto;
                .fixedByCover();
                background-color: rgba(0,0,0,.6);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 1000;

                >.dailog-wrap{
                    width: 80%;
                    background-color: @themeReverseColor;
                    padding: @36px;
                    border-radius: @radiusNumber;

                    >.h-box{
                        text-align: center;
                        font-size: @fontSizeA3;
                    }

                    >.c-box{
                        margin: @36px 0px;
                        >img{width: 100%}
                    }

                    >.btn-box{
                        >a{
                            display: inline-block;
                            width: 100%;
                            height: @standartHeightA4;
                            line-height: @standartHeightA4;
                            border-radius: @standartHeightA4/2;
                            background-color: @themeColor;
                            color: @themeReverseColor;
                            text-align: center;
                            &:active{opacity:.8;}
                        }
                    }

                }
            }

            >.photo-sphere-viewer-fixed{
                .fixedByCover();
                z-index: 1000;
                background-color: @maskBgColor;
                display: flex;
                justify-content: center;
                align-items: center;
                pointer-events: auto;

                >.icon-yanjizhushou-shangchuan_tuoluoyi{
                    position: absolute;
                    top: @50px;
                    left: @80px;
                    font-size: @110px;
                    color: @themeColor;
                    z-index: 1000;

                    position: absolute;
                    transform: translateX(-50%);
                    line-height: 1;
                    opacity: .8;
                    z-index: 10;
                    color: @themeReverseColor;

                    &:active{
                        opacity: .8;
                    }
                }

                >.photosphere{
                    width: 100vw;
                    height: 100vh;
                    background-color: @themeReverseColor;
                    position: relative;
                    //border-radius: @radiusNumber;
                    overflow: hidden;

                    >.icon-close-01{
                        position: absolute;
                        bottom: @50px;
                        left: 50%;
                        transform: translateX(-50%);
                        line-height: 1;
                        font-size: @110px;
                        opacity: .4;
                        z-index: 1000;
                        color: #333333;

                        &:active{
                            opacity: .8;
                        }
                    }
                }
            }
        }

    }

</style>
